import RoutesEnum from 'enums/routes.enum'
import LoadSessionMiddleware from 'middlewares/LoadSessionMiddleware'
import RequireUserMiddleware from 'middlewares/RequireUserMiddleware'

export default [
    {
        path: '/home',
        name: RoutesEnum.SUBDOMAIN.COMPANY,
        view: 'subdomain/Company',
        middlewares: [LoadSessionMiddleware],
        meta: {
            layout: 'main',
            title: 'Bookeraj - Rezerviši i Pruži Usluge Online',
            description:
                'Naše online mesto vam omogućava da lako rezervišete različite usluge ili ponudite svoje usluge drugima. Pronađite i rezervišite ono što vam treba.',
        },
    },
    {
        path: '/reservations/my/:type',
        name: RoutesEnum.SUBDOMAIN.RESERVATIONS,
        view: 'reservations/MyReservations',
        middlewares: [LoadSessionMiddleware, RequireUserMiddleware],
        meta: {
            layout: 'main',
            title: 'Bookeraj - Rezerviši i Pruži Usluge Online',
            description:
                'Naše online mesto vam omogućava da lako rezervišete različite usluge ili ponudite svoje usluge drugima. Pronađite i rezervišite ono što vam treba.',
        },
    },
    {
        path: '/offers',
        name: RoutesEnum.SUBDOMAIN.OFFER,
        view: 'subdomain/CompanyOffers',
        middlewares: [LoadSessionMiddleware],
        meta: {
            layout: 'main',
            title: 'Bookeraj - Rezerviši i Pruži Usluge Online',
            description:
                'Naše online mesto vam omogućava da lako rezervišete različite usluge ili ponudite svoje usluge drugima. Pronađite i rezervišite ono što vam treba.',
        },
    },
    {
        path: '/contact',
        name: RoutesEnum.SUBDOMAIN.CONTACT,
        view: 'contact/Contact',
        middlewares: [LoadSessionMiddleware],
        meta: {
            layout: 'main',
            title: 'Bookeraj - Rezerviši i Pruži Usluge Online',
            description:
                'Naše online mesto vam omogućava da lako rezervišete različite usluge ili ponudite svoje usluge drugima. Pronađite i rezervišite ono što vam treba.',
        },
    },
]
